import React from "react";
import { useRecoilState, useSetRecoilState } from "recoil";

import {
	FormControl,
	FormLabel,
	FormControlLabel,
	Radio,
	RadioGroup,
} from "@mui/material";

import { TRAVEL_TYPES, travelTimeLoadingAtom, travelTimeOptionsAtom } from './atoms'

export default function TravelTypeSelector() {
	const defaultValue = TRAVEL_TYPES.find((tt) => tt.default)?.value
	const setTravelTimeLoading = useSetRecoilState(travelTimeLoadingAtom)
	const [travelTimeOptions, setTravelTimeOptions] = useRecoilState(travelTimeOptionsAtom)
  const [timer, setTimer] = React.useState(null)
  const [travelType, setTravelType] = React.useState(defaultValue)

  const updateTravelType = (e) => {
  	clearTimeout(timer);
  	setTravelTimeLoading(true)
  	setTravelType(e.target.value)
  };

  const afterTimeout = () => {
    setTravelTimeOptions({
      ...travelTimeOptions,
      type: travelType,
    })
  }

  React.useEffect(() => {
		const t = setTimeout(afterTimeout, 1000);
		setTimer(t)
  }, [travelType])

  const renderRadioButton = (travelType) => {
  	return (
  		<Radio
  			aria-label={travelType.label}
  			size="small" />
  	)
  }

	const renderRadioControl = (travelType) => (
		<FormControlLabel
			key={travelType.value}
			control={renderRadioButton(travelType)}
			value={travelType.value}
			label={travelType.label}
			sx={{
				width: "180px",
				marginBottom: -1,
			}}/>
	)

	return (
		<FormControl sx={{
			mb: 2,
			ml: 3,
		}}>
			<FormLabel
				id="travel-time-type-selector-label"
				sx={{
					fontSize: "11px",
					color: '#868b8e',
					marginBottom: '2px',
				}}>
				Type
			</FormLabel>
			<RadioGroup
				row
				name="travel-time-type-selector"
				aria-labelledby="travel-time-type-selector-label"
				defaultValue={defaultValue}
				onChange={updateTravelType}>
				{TRAVEL_TYPES.map((travelType) => renderRadioControl(travelType))}
			</RadioGroup>
		</FormControl>
	)
}